/**
 * @typedef {Object} IsMobileMixin
 * @property {boolean} isMobile - Whether the current viewport is mobile sized
 */

/**
 * Mixin that adds isMobile data property to Vue components
 * @type {import('vue').VueConstructor}
 */
export const useIsMobileMixin = {
  data() {
    return {
      /** @type {boolean} */
      isMobile: false
    };
  },

  created() {
    const BREAKPOINT = 768;

    const checkIsMobile = () => {
      this.isMobile = window.innerWidth <= BREAKPOINT;
    };

    const resizeHandler = () => {
      checkIsMobile();
    };

    window.addEventListener('resize', resizeHandler, {
      passive: true
    });

    checkIsMobile();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  }
};
